module.exports = __webpack_public_path__ + "static/media/webpage.bb1d744b.webp";